var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { load } from 'cheerio';
// Hoist styling to body to fix styling issue in AB tests https://forum.builder.io/t/a-b-test-variations-styling-doesn-t-often-look-right-using-emotion-css-styling-with-next-js/1197
const extractABTestingStyles = (body) => {
    let globalStyles = '';
    if (body.includes('<template')) {
        const $ = load(body);
        const templates = $('template');
        templates.toArray().forEach((element) => {
            const str = $(element).html();
            const styles = load(String(str))('style');
            globalStyles += styles
                .toArray()
                .map((el) => $(el).html())
                .join(' ');
        });
    }
    return globalStyles;
};
export function getGlobalStyles(ctx) {
    return __awaiter(this, void 0, void 0, function* () {
        const originalRenderPage = ctx.renderPage;
        let globalStyles = '';
        ctx.renderPage = (options) => __awaiter(this, void 0, void 0, function* () {
            const render = yield originalRenderPage(options);
            globalStyles = extractABTestingStyles(render.html);
            return render;
        });
        return globalStyles;
    });
}
//# sourceMappingURL=getGlobalStyles.js.map